import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import Button from 'app/components/ButtonDefault'
import { ModalBody, ModalTitle } from 'app/components/Modal'
import ButtonArrow from 'app/components/ButtonArrow'
import Slider from 'app/components/Slider'

import SliderCard from './SliderCard'

import './styles.scss'

const baseClass = 'onboarding-view-example-popup'

const sliderSettings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [],
  infinite: true,
  prevArrow: <ButtonArrow left buttonClass={`${baseClass}__arrow ${baseClass}__arrow--left`} />,
  nextArrow: <ButtonArrow right buttonClass={`${baseClass}__arrow ${baseClass}__arrow--right`} />,
}

const ViewExamplesPopup = ({ t, onRequestClose, subscribeToProTrack, protrackLevel }) => (
  <ModalBody onRequestClose={onRequestClose} className={baseClass}>
    <ModalTitle>
      {`${protrackLevel.get('proTrackName')} (${protrackLevel.get('name')})`} {t('Daily Activity Examples')}
    </ModalTitle>
    <div className={`${baseClass}__goals`}>
      <span>{t('Goals')} </span> {protrackLevel.get('goals')}
    </div>
    <div className={`${baseClass}__activities`}>
      {protrackLevel.get('exampleActivities').length === 1 ? (
        // It's a hack because slider component doesn't render one slide correctly with infinite scroll. Maybe should be moved to slider
        <SliderCard {...protrackLevel.get('exampleActivities')[0]} />
      ) : (
        <Slider items={protrackLevel.get('exampleActivities')} card={SliderCard} settings={sliderSettings} />
      )}
    </div>
    <div className={`${baseClass}__footer`}>
      <Button
        primary
        onClick={() => {
          subscribeToProTrack({ proTrackLevelId: protrackLevel.get('id') })
          onRequestClose()
        }}
      >
        {`${t('Select')} ${protrackLevel.get('proTrackName')} (${protrackLevel.get('name')})`}
      </Button>
    </div>
  </ModalBody>
)

ViewExamplesPopup.propTypes = {
  onRequestClose: PropTypes.func,
  subscribeToProTrack: PropTypes.func.isRequired,
}

export default withTranslation('user')(ViewExamplesPopup)
